import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: parseInt(searchParams.get('startFrom') || '') || 2,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 100,

    sizeQR: searchParams.get('sizeQR') || '46.25',
    authorFontSize: searchParams.get('authorFontSize') || '5.6',
  };
};
